import { render, staticRenderFns } from "./Teen10.vue?vue&type=template&id=0f9ce098&scoped=true&"
import script from "./Teen10.vue?vue&type=script&lang=js&"
export * from "./Teen10.vue?vue&type=script&lang=js&"
import style0 from "./Teen10.vue?vue&type=style&index=0&id=0f9ce098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9ce098",
  null
  
)

export default component.exports